import { render } from "./ReportBuilder.vue?vue&type=template&id=6e77b848"
import script from "./ReportBuilder.vue?vue&type=script&setup=true&lang=js"
export * from "./ReportBuilder.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/Pages/Insights/ReportBuilder.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6e77b848"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6e77b848', __exports__)) {
    api.reload('6e77b848', __exports__)
  }
  
  module.hot.accept("./ReportBuilder.vue?vue&type=template&id=6e77b848", () => {
    api.rerender('6e77b848', render)
  })

}


export default __exports__